import cn from 'classnames';
import React from 'react';
import { useForm } from 'react-hook-form';
import { InstanceProps, create } from 'react-modal-promise';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';
import { Form as FormComponent, Input } from 'components/form';

import styles from './ButtonModal.module.scss';

const ModalInstance: React.FC<
  InstanceProps<{ title: string; link: string } | null>
> = ({ isOpen, onResolve, onReject }) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  const onSubmitForm = async (data: { title: string; link: string }) => {
    onResolve({ ...data });
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      contentClassName={cn(styles.container, {})}
      className={styles.modal}
    >
      <FormComponent
        autoComplete="off"
        className={styles.form}
        onSubmit={handleSubmit(onSubmitForm)}
        onKeyDown={handleKeyDown}
      >
        <div className={styles.header}>
          <div className={styles['header-wrapper']}>
            <p className={styles.title}>Add button</p>
            <IconButton
              size="small"
              iconName="close"
              className={styles['cancel-icon']}
              onClick={() => onReject()}
            />
          </div>
        </div>
        <div className={styles['input-wrapper']}>
          <div className={styles['input-container']}>
            <Input
              autoFocus
              type="title"
              label="Button text"
              placeholder=""
              {...register('title', {
                required: 'Required',
              })}
              inputClassName={styles.input}
            />
          </div>
          <div className={styles['input-container']}>
            <Input
              type="link"
              label="URL"
              placeholder=""
              {...register('link', {
                required: 'Required',
              })}
              inputClassName={styles.input}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <ButtonV3
            size="medium"
            type="submit"
            isLoading={isSubmitting}
            className={styles.button}
          >
            Done
          </ButtonV3>
          <ButtonV3
            color="secondary"
            size="medium"
            isLoading={isSubmitting}
            className={styles.button}
            onClick={() => onReject()}
          >
            Cancel
          </ButtonV3>
        </div>
      </FormComponent>
    </Modal>
  );
};

export const buttonModal = create(ModalInstance);
